<template>
  <div class="content_fujian">
    <div class="tableBox" v-if="done == 0">
      <van-field v-model="fieldValue" is-link readonly label="业务类型" placeholder="请选择业务类型" @click="show = true" />
      <van-popup v-model="show" round position="bottom">
        <van-cascader v-model="tdtype" title="请选择业务类型" :options="options" @close="show = false" @finish="onFinish"
          @change="getstype" active-color="#438CFF" />
      </van-popup>
      <van-field v-model="fieldValueTd" is-link readonly label="图档类型" placeholder="请选择图档类型" @click="showTd = true" />
      <van-popup v-model="showTd" round position="bottom">
        <van-cascader v-model="tdstype" title="请选择图档类型" :options="optionsTd" @close="showTd = false" @finish="onFinishTd"
          active-color="#438CFF" />
      </van-popup>
      <van-row>
        <van-col span="8">
          <div style="margin: 11px 0 5px 10px; font-size: 14px; font-weight: bold">附件上传</div>
        </van-col>
        <van-col span="12"></van-col>
        <van-col span="4">
          <van-button v-if="isApp" :disabled="!(fieldValue && fieldValueTd)" @click="pickFile"
            style="margin: 5px 0 0 0; border: none; color: #438CFF;" size="small">
            上传
          </van-button>
          <van-uploader v-else :disabled="!(fieldValue && fieldValueTd)" accept="*" :after-read="afterRead"
            :before-read="beforeRead">
            <van-button style="margin: 5px 0 0 0; border: none; color: #438CFF;" size="small">上传</van-button>
          </van-uploader>
        </van-col>
      </van-row>
    </div>
    <van-list class="list">
      <van-cell v-for="(item, index) in list" :key="index" :title="item.fileName">
        <template>
          <van-button style="border: none; color:#438CFF" size="mini" @click="previewFile(item)">预览</van-button>
          <van-button size="mini" @click="downFile('downLink' + index)" style="border: none;">
            <a style="color:#438CFF" :id="'downLink' + index"
              :href="$axios.defaults.baseURL + '/flow/file/downloadFileById?fileId=' + item.id" download>下载</a>
          </van-button>
          <van-button style="border: none; color:#438CFF" size="mini" v-if="done == 0"
            @click="delfile(item, index)">删除</van-button>
        </template>
      </van-cell>
    </van-list>
  </div>
</template>

<script>
import { Toast, Dialog } from 'vant';
import { Base64 } from 'js-base64';
import Bridge from "@/utils/Bridge";
export default {
  data() {
    return {
      show: false,
      fieldValue: '',
      showTd: false,
      fieldValueTd: '',
      stype: null,
      type: null,
      tdtype: null,
      tdstype: null,
      list: [],
      filePaths: [],
      done: false,
      options: [],
      optionsTd: [],
      isApp: false
    }
  },
  created() {
    this.done = sessionStorage.getItem('done')
    this.initit()
    let userAgent = window.navigator.userAgent;
    if (userAgent.indexOf("dimine") != -1) {
      this.isApp = true
    } else {
      this.isApp = false
    }
  },
  methods: {
    pickFile() {
      window.selectFileResult = this.selectFileResult;
      Bridge.callSyncMethod("nativeRequest", {
        nativeMethod: "selectFile"
      });
    },
    async uploadCooperateFileResult(resultJson) {
      const { code, msg } = JSON.parse(resultJson.uploadResult)
      Toast(msg)
      if (code == 0) {
        this.list = []
        let res = await this.$post('/flow/file/selectFileByBizId?pageNum=1&pageSize=30&bizId=' + this.$route.query.bizId)
        for (let k = 0; k < res.data.data.length; k++) {
          this.list.push({
            id: res.data.data[k].id,
            fileName: res.data.data[k].fileName,
            fileType: res.data.data[k].fileType
          })
        }
      }
    },
    selectFileResult(resultJson) {
      let obj = {
        "workflowId": this.$route.query.bizId,
        "opertionType": 0,
        "professionalCategory": this.tdtype,
        "archiveCategory": this.tdstype
      }
      Bridge.callSyncMethod("nativeRequest", {
        nativeMethod: "uploadCooperateFile",
        data: {
          Authorization: sessionStorage.getItem('usertoken'),
          obj: JSON.stringify(obj),
          filePath: resultJson.filePath,
        }
      });
      window.uploadCooperateFileResult = this.uploadCooperateFileResult
    },
    previewFile(row) {
      let typeArr = ['.dmf', '.dwg', '.dxf', '.bmp', '.dmt', '.dmd', '.dmb', '.dmx', '.dmo']
      let imageType = ".png,.jpg,.jpeg,.gif"
      if (typeArr.indexOf(row.fileType) != -1) {
        this.$router.push({ path: '/task/preview', query: { fileid: row.id, filename: row.fileName,fileType:row.fileType } })
      } else if(imageType.indexOf(row.fileType) != -1){
        this.$router.push({ path: '/task/preview', query: {fileid:row.id,filename:row.fileName,fileType:row.fileType}})
      } else {
        let url = 'http://dmmcp-system:8088/flow/file/downloadFileById?fileId=' + row.id + '&fullfilename=' + row.fileName
        this.$router.push({ path: '/task/preview', query: { url: encodeURIComponent(Base64.encode(url)) } })
      }
    },
    async initit() {
      // 4  初始化附件上传业务类型
      let res = await this.$get('/system/dict/data/dictType/tdgl')
      this.type = res.data.concat()
      for (let i = 0; i < this.type.length; i++) {
        let res = JSON.parse(
          JSON.stringify(this.type[i])
            .replace(/dictLabel/g, 'text')
            .replace(/dictValue/g, 'value')
        );
        this.options.push(res);
      }

      // 取附件列表信息
      res = await this.$post('/flow/file/selectFileByBizId?pageNum=1&pageSize=30&bizId=' + this.$route.query.bizId)
      for (let k = 0; k < res.data.data.length; k++) {
        this.list.push({
          id: res.data.data[k].id,
          fileName: res.data.data[k].fileName,
          fileType: res.data.data[k].fileType
        })
      }
    },
    async delfile(item, index) {
      Dialog.confirm({
        title: '提示',
        message: '是否确定删除?',
      }).then(async () => {
        const { code, msg } = await this.$del('/flow/file/delete/' + item.id)
        Toast(msg)
        if (code == 0) {
          this.list.splice(index, 1)
        }
      }).catch(() => { });
    },
    beforeRead(file) {
      if (!this.tdtype || !this.tdstype) {
        Toast('请选择上传文件的业务类型、图档类型')
        return false
      }
      // if (file.type.startsWith('image'))
      //   return true;
      // Toast('请选择图片文件')
      return true
    },
    async afterRead(file) {
      console.log(file)
      let obj = {
        "workflowId": this.$route.query.bizId,
        "opertionType": 0,
        "professionalCategory": this.tdtype,
        "archiveCategory": this.tdstype
      }
      // 开始上传
      var upData = new FormData();
      upData.append("file", file.file, file.file.name)
      upData.append("obj", JSON.stringify(obj))
      upData.append("Authorization", sessionStorage.getItem('usertoken'))
      const { code, msg } = await this.$post('/flow/file/add', upData, 'application/json')
      Toast(msg)
      if (code == 0) {
        this.list = []
        let res = await this.$post('/flow/file/selectFileByBizId?pageNum=1&pageSize=30&bizId=' + this.$route.query.bizId)
        for (let k = 0; k < res.data.data.length; k++) {
          this.list.push({
            id: res.data.data[k].id,
            fileName: res.data.data[k].fileName,
            fileType: res.data.data[k].fileType
          })
        }
      }
    },
    async getstype() {
      // 附件上传图档类型
      const { data } = await this.$get('/system/dict/data/dictType/' + this.tdtype)
      this.stype = data.concat();
      for (let i = 0; i < this.stype.length; i++) {
        let res = JSON.parse(
          JSON.stringify(this.stype[i])
            .replace(/dictLabel/g, 'text')
            .replace(/dictValue/g, 'value')
        );
        this.optionsTd.push(res);
      }
    },
    onFinish({ selectedOptions }) {
      this.show = false
      this.fieldValue = selectedOptions.map((option) => option.text).join('/')
    },
    onFinishTd({ selectedOptions }) {
      this.showTd = false
      this.fieldValueTd = selectedOptions.map((option) => option.text).join('/')
    },
    downFile(downid) {
      var a = document.getElementById(downid)
      a.click()
    }
  }
}
</script>


<style lang="less" scoped>
// .content_fujian {
.h4 {
  font-size: 36px;
  font-weight: 600;
  padding-left: 15px;
  margin-top: 10px;
}

.tableBox {
  margin-top: 30px;

  .add {
    font-size: 26px;
    padding-right: 30px;
    height: 60px;
    line-height: 60px;
    position: relative;
    border: 2px solid #dadada;
    border-top: 0;
    text-align: right;
    color: #438cff;
  }

  .tables {
    .thLeft {
      text-align: left;
    }
  }
}

// }
</style>



// WEBPACK FOOTER //
// src/pages/tasks/fujian.vue